import React, { Suspense } from 'react'

const LeaveReviewPageBase = React.lazy(() => import('./LeaveReview'))

export const LeaveReviewPage = () => (
  <Suspense fallback={null}>
    <LeaveReviewPageBase />
  </Suspense>
)
